import SeatChangeConfirmModal from 'components/seat-change-confirm-modal';
import { useState } from 'react';
import { useGetCurrentPaymentPlanQuery } from 'redux-store/api/billing';

type SeatAction = () => unknown | Promise<unknown>;

export const useSeatChangeGuard = () => {
  const { data: currentPlan } = useGetCurrentPaymentPlanQuery();
  const [pending, setPending] = useState<{
    targetSeatCount: number;
    action: SeatAction;
  } | null>(null);

  const isSeatBased = currentPlan?.seatBasedPricing === true;
  const currentSeatCount = currentPlan?.activeUsersAmount ?? 0;

  const requestSeatChange = (targetSeatCount: number, action: SeatAction) => {
    if (!isSeatBased) {
      action();
      return;
    }

    setPending({ targetSeatCount, action });
  };

  const seatChangeModal = pending ? (
    <SeatChangeConfirmModal
      targetSeatCount={pending.targetSeatCount}
      onConfirmed={pending.action}
      onClose={() => setPending(null)}
    />
  ) : null;

  return { requestSeatChange, seatChangeModal, currentSeatCount, isSeatBased };
};
